import * as DIAG from "storm-react-diagrams";
import BaseDiagramModel from "./models/BaseDiagramModel";
import LinkFactory from "./graph_components/LinkFactory";
import NodeFactory from "./graph_components/NodeFactory";
import PreviewNodeFactory from "./graph_components/previews/PreviewNodeFactory";
import PreviewLinkFactory from "./graph_components/previews/PreviewLinkFactory";
import NodeRegistry from "./utilities/NodeRegistry";

export default class Graph {
    /**
     * Graph model of application diagram
     * @module Graph
     * @param {Object} serialized Serialized app model
     * @param {boolean} isPreview If true, use preview factories
     */
    constructor(serialized, isPreview = false, version = 1) {
        this.graphEngine = new DIAG.DiagramEngine();

        if (isPreview){
            this.graphEngine.registerNodeFactory(new PreviewNodeFactory());
            this.graphEngine.registerLinkFactory(new PreviewLinkFactory());
        } else {
            this.graphEngine.registerNodeFactory(new NodeFactory());
            this.graphEngine.registerLinkFactory(new LinkFactory());
        }

        this.initModel(serialized, version);
    }

    /**
     * Initialize model with default and custom flow via props
     * @param {Object} serialized Serialized app model
     */
    initModel(mod, version) {
        this.graphModel = new BaseDiagramModel(mod.id);
        this.graphEngine.setDiagramModel(this.graphModel);

        if (mod.hasOwnProperty("version") && mod.versions && mod.versions[version].flow) {
            const flow = mod.versions[version].flow;
            this.graphModel.suppressBroadcast = true;
            for (var i = 0; i < flow.nodes.length; i++) {
                const nodeElement = flow.nodes[i];
                const newNode = NodeRegistry.buildNode(nodeElement);
                //newNode.props.flowVersion = version;
                this.graphModel.addNode(newNode, {graphModel: mod, version: version});
            }
            for (var i = 0; i < flow.links.length; i++) {
                const linkElement = flow.links[i];
                if (linkElement.source && linkElement.target) {
                    try{
                        const sourcePort = (this.graphModel.getNode(linkElement.source).getPorts())[linkElement.sourcePort];
                        const targetPort = (this.graphModel.getNode(linkElement.target).getPorts())[linkElement.targetPort];
                        const newLink = new NodeRegistry.r[linkElement._class](sourcePort, targetPort, linkElement.props, linkElement.id, linkElement.points);
                        this.graphModel.addLink(newLink);
                    } catch(e) {
                        // TODO: hot-fix DEVDES2-703
                        console.log(e);
                    }
                    
                }
            }
            this.graphModel.suppressBroadcast = false;
        }
    }

    /**
     * Get diagram data model
     * @returns {BaseDiagramModel}
     */
    getModel() {
        return this.graphModel;
    }

    /**
     * Get diagram engine
     * @returns {DIAG.DiagramEngine}
     */
    getEngine() {
        return this.graphEngine;
    }
}
